// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"7435e6b6","488":"cb3deacc"}[chunkId] + ".chunk.js";
};